import { createContext, useState, ReactNode } from 'react';

// ----------------------------------------------------------------------

type LoaderContextProps =
{
    loading : boolean;
    startLoader: VoidFunction;
    endLoader: VoidFunction;
};



// ----------------------------------------------------------------------
const initialState : LoaderContextProps =
{
    loading : false,
    startLoader: () => {},
    endLoader: () => {}
};

const LoaderContext = createContext(initialState);

type LoaderContextProviderProps = {
    children: ReactNode;
  };

function LoaderContextProvider({ children }: LoaderContextProviderProps) {
    const[loadingState, setLoadingState] = useState(false);
    
    return (
        <LoaderContext.Provider value={
            { 
                loading: loadingState,
                startLoader: () => {setLoadingState(true);},
                endLoader: () => {setLoadingState(false);}
            }}
            >
            { children }
        </LoaderContext.Provider>
  );
}

export { LoaderContext, LoaderContextProvider };
